import { FETCH_PERSON_CONTACTS_DATA } from 'stores/redux/actions/types';
import reducer from '../common/reducer';

const addReducer = reducer(FETCH_PERSON_CONTACTS_DATA, []);
export default addReducer;
